import api from './api';

export function getExternalUsers() {
  return api.get('/api/v2/external-users');
}

export function addExternalUser(user) {
  return api.post('/api/v2/external-users', user);
}

export function updateExternalUser(user) {
  return api.put(`/api/v2/external-users/${user.id}`, user);
}

export function deleteExternalUser(user) {
  return api.delete(`/api/v2/external-users/${user.id}`);
}
